
// import React, { useEffect, useState } from 'react';
// import Counter from './Counter';

// export default function CircularProgressBar() {

//   return (
//     <>

//   <div className="flex  bg-fruit flex-col items-center justify-center border-2
//    min-h-5/6 ">
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 ">
 
//           <div  className=" p-8  ">
//             <h5 className="text-4xl font-bold mb-4"><Counter targetValue={27}/></h5>
//             <p className='text-white text-center align-middle text-xl'data-aos="zoom-in"data-aos-delay="50"
//      data-aos-duration="1000">
         
         
//               Our Team</p>
//               <p className='text-white text-center align-middle text-lg'data-aos="zoom-in"data-aos-delay="50"
//      data-aos-duration="1000">
         
         
//               We continue to grow nationally and internationally.</p>

//           </div>
//           <div  className=" p-8 ">
//             <h5 className="text-4xl font-bold mb-4"><Counter targetValue={35}/></h5>
//             <p className='text-white text-center align-middle text-lg'data-aos="zoom-in"data-aos-delay="50"
//      data-aos-duration="1000">
   
   
//               Our Client</p>
//               <p className='text-white text-center align-middle text-lg'data-aos="zoom-in"data-aos-delay="50"
//      data-aos-duration="1000">
         
         
//               An experienced team and legacy of Success</p>
//           </div>
//           <div  className=" p-6 ">
//             <h5 className="text-4xl text-white font-bold mb-4"><Counter targetValue={20}/></h5>
//             <p className='text-white text-center align-middle text-xl'data-aos="zoom-in"data-aos-delay="50"
//      data-aos-duration="1000">
   
   
//               Our Experience</p>
//             <p className='text-white text-center align-middle text-xl'data-aos="zoom-in"data-aos-delay="50"
//      data-aos-duration="1000">
         
         
//             From different industries we cater to everyone</p>
//           </div>
     
//       </div>
//     </div>

//     </>
//   )
// }




import React, { useEffect, useState, useRef } from 'react';
import Counter from './Counter';

export default function CircularProgressBar() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true); // Trigger the counter when the section becomes visible
          observer.unobserve(entries[0].target); // Stop observing once the counter has started
        }
      },
      { threshold: 0.3 } // Adjust the threshold as per your requirement
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef} // Attach the ref to the section to observe
      className="flex bg-fruit flex-col items-center justify-center border-2 min-h-5/6"
    >
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {isVisible && (
          <>
            <div className="p-8">
              <h5 className="text-4xl font-bold mb-4">
                <Counter targetValue={27} />
              </h5>
              <p className="text-white text-center align-middle text-xl" data-aos="zoom-in" data-aos-delay="50" data-aos-duration="1000">
                Our Team
              </p>
              <p className="text-white text-center align-middle text-lg" data-aos="zoom-in" data-aos-delay="50" data-aos-duration="1000">
                We continue to grow nationally and internationally.
              </p>
            </div>
            <div className="p-8">
              <h5 className="text-4xl font-bold mb-4">
                <Counter targetValue={35} />
              </h5>
              <p className="text-white text-center align-middle text-lg" data-aos="zoom-in" data-aos-delay="50" data-aos-duration="1000">
                Our Client
              </p>
              <p className="text-white text-center align-middle text-lg" data-aos="zoom-in" data-aos-delay="50" data-aos-duration="1000">
                An experienced team and legacy of Success
              </p>
            </div>
            <div className="p-6">
              <h5 className="text-4xl text-white font-bold mb-4">
                <Counter targetValue={20} />
              </h5>
              <p className="text-white text-center align-middle text-xl" data-aos="zoom-in" data-aos-delay="50" data-aos-duration="1000">
                Our Experience
              </p>
              <p className="text-white text-center align-middle text-xl" data-aos="zoom-in" data-aos-delay="50" data-aos-duration="1000">
                From different industries we cater to everyone
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
